import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getFnbPriceChanges } from "./priceChanges.thunk";

const init_state = {
  priceChangesData: {
    data: [],
    pagination: {
      total: 0,
      limit: 50,
      offset: 0,
      pages: 0,
    },
  },
  loading: false,
  error: null,
};

export const fetchFnbPriceChanges = createAsyncThunk(
  "fnb/priceChanges",
  getFnbPriceChanges
);

const fnbPriceChangesSlice = createSlice({
  name: "fnb price changes",
  initialState: init_state,
  reducers: {
    clearPriceChanges: (state) => {
      state.priceChangesData = init_state.priceChangesData;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchFnbPriceChanges.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchFnbPriceChanges.fulfilled, (state, action) => {
        if (action.payload?.status === "success") {
          state.priceChangesData = {
            data: action.payload.data,
            pagination: action.payload.pagination,
          };
        }
        state.loading = false;
      })
      .addCase(fetchFnbPriceChanges.rejected, (state, action) => {
        state.error = action.payload;
        state.loading = false;
      });
  },
});

export const { clearPriceChanges } = fnbPriceChangesSlice.actions;
export default fnbPriceChangesSlice.reducer;
